import VxeCheckboxGroupComponent from '../checkbox/src/group';
import { dynamicApp } from '../dynamics';
export var VxeCheckboxGroup = Object.assign(VxeCheckboxGroupComponent, {
    install: function (app) {
        app.component(VxeCheckboxGroupComponent.name, VxeCheckboxGroupComponent);
    }
});
export var CheckboxGroup = VxeCheckboxGroup;
dynamicApp.component(VxeCheckboxGroupComponent.name, VxeCheckboxGroupComponent);
export default VxeCheckboxGroup;
